import { render, staticRenderFns } from "./WhStaff.vue?vue&type=template&id=34aeb2f7&scoped=true&"
import script from "./WhStaff.vue?vue&type=script&lang=js&"
export * from "./WhStaff.vue?vue&type=script&lang=js&"
import style0 from "./WhStaff.vue?vue&type=style&index=0&id=34aeb2f7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aeb2f7",
  null
  
)

export default component.exports